export const chartColors = [
  "#0040FF",
  "#3366FF",
  "#668CFF",
  "#99B3FF",
  "#CCD9FF",
];
